import Transfer, { SupplierTransfer } from "ts/api/transfer";
import { Roles } from "@evennt-tech/api-v2-core";
import Order, { BankTransferOrder, OrderStatus } from "ts/api/order";
import {
  isOrderBankTransfer,
  isOrderCardOrIdeal,
} from "tools/order/isOrderCardOrIdeal";

export const isTransferSupplier = (
  transfer: Transfer
): transfer is SupplierTransfer & { transferredPaymentDescription: string } =>
  transfer.metadata?.role === Roles.SUPPLIER;
export const findSupplierTransfer = (
  transfers: Transfer[],
  supplierCompanyId: string
) =>
  (transfers ?? []).find(
    (t) => isTransferSupplier(t) && t.metadata.id === supplierCompanyId
  );

export const getSupplierInvoice = (
  order: BankTransferOrder,
  supplierId: string
) =>
  Object.values(order.invoices).find((invoice) =>
    invoice?.products?.some((product) => product.owner.id === supplierId)
  );

export const getSupplierTransfer = (
  order: Order,
  supplierCompanyId: string
): Transfer | null => {
  if (isOrderBankTransfer(order)) {
    const invoice = getSupplierInvoice(order, supplierCompanyId);
    if (invoice?.status !== "paid") return null;
    const transfer = findSupplierTransfer(invoice.transfers, supplierCompanyId);
    return transfer ?? null;
  }
  if (isOrderCardOrIdeal(order)) {
    const transfer = findSupplierTransfer(order.transfers, supplierCompanyId);
    return transfer ?? null;
  }
  return null;
};
